import { Injectable, APP_INITIALIZER } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';



import { using } from 'rxjs';
import { environment } from './environment.prod';


@Injectable()
export class ConfigService {

    private _config: Object
    private _env: string;

    constructor(private _http: HttpClient) {
        // ConfigModule.init();
     }
    load() {
        
        return new Promise((resolve, reject) => {
            this._env = 'development';
            if (environment.production)
                this._env = 'production';
            console.log(this._env)
            
            this._http.get('assets/environments/' + this._env + '.json')
          .pipe(map(
            (res: HttpResponse<any>) => {
                
                return res
            }))
            .subscribe((item) => {
                this._config = item;
                resolve(true);
            },
            (err) => {
                
            })
          ;
            
        });
    }
    
    // Is app in the development mode?
    isDevmode() {
        return this._env === 'development';
    }
    // Gets API route based on the provided key
    getApi(key: string): string {
        return this._config["API_ENDPOINTS"][key];
    }
    // Gets a value of specified property in the configuration file
    get(key: any) {
        return this._config[key];
    }
}

export function ConfigFactory(config: ConfigService) {
    return () => config.load();
}

export function init() {
    return {
        provide: APP_INITIALIZER,
        useFactory: ConfigFactory,
        deps: [ConfigService],
        multi: true
    }
}

const ConfigModule = {
    init: init
}

export { ConfigModule };